import { Component, OnInit } from '@angular/core';
import {NgForm} from '@angular/forms';
import {Store} from '@ngrx/store';

import * as fromApp from '../../store/app.reducers';
import * as AuthActions from '../store/auth.actions';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.scss'],
    standalone: false
})
export class SigninComponent implements OnInit {

  showPassword = false;
  isLoading = false;
  forgotPasswordUrl = environment.mainPage + '/remind/password/1';

  constructor(
    private store: Store<fromApp.AppState>
  ) { }

  ngOnInit() {
  }

  onSignin(form: NgForm) {
    this.isLoading = true;
    const email = form.value.email;
    const password = form.value.password;

    this.store.dispatch(
      new AuthActions.TrySignin({
        email: email,
        password: password
      })
    );
  }

}
